import {dashboardRoutes} from '@/areas/dashboard/routes';
import {landingRoutes} from '@/areas/landing/routes';
import {studentCenterRoutes} from '@/areas/student-center/routes';

export default [
   landingRoutes,
   studentCenterRoutes,
   dashboardRoutes,
];
